import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FiMail, FiShield, FiX } from 'react-icons/fi';

export function SecurityCheckModal({
  open,
  emailBound,
  onBindEmail,
  onClose,
}) {
  const { t } = useTranslation();
  const [skipWarning, setSkipWarning] = useState(false);

  useEffect(() => {
    if (open) {
      setSkipWarning(false);
    }
  }, [open]);

  if (!open) return null;

  const handleSkip = () => {
    if (!skipWarning) {
      setSkipWarning(true);
      return;
    }
    onClose?.();
  };

  const emailStatusLabel = emailBound
    ? t('security.emailStatusBound')
    : t('security.emailStatusUnbound');

  return (
    <div className="fixed inset-0 z-[150] flex items-center justify-center bg-black/60 px-4">
      <div className="w-full max-w-lg rounded-2xl border border-glass-border bg-surface/95 p-6 text-slate-100 shadow-[0_30px_70px_rgba(0,0,0,0.45)]">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-slate-500">
              <FiShield className="text-amber-300" />
              {t('security.title')}
            </div>
            <div className="mt-2 text-lg font-semibold text-white">
              {t('security.subtitle')}
            </div>
          </div>
          <button
            className="rounded-full border border-glass-border p-2 text-slate-300 hover:text-white"
            onClick={onClose}
          >
            <FiX size={16} />
          </button>
        </div>

        <div className="mt-5 space-y-4">
          <div className="rounded-xl border border-glass-border bg-surface-highlight/40 p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2 text-sm font-semibold text-white">
                <FiMail className="text-accent" />
                {t('security.emailTitle')}
              </div>
              <span
                className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${
                  emailBound
                    ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300'
                    : 'border-amber-500/30 bg-amber-500/10 text-amber-200'
                }`}
              >
                {emailStatusLabel}
              </span>
            </div>
            <p className="mt-2 text-xs text-slate-400">
              {emailBound ? t('security.emailDescBound') : t('security.emailDescUnbound')}
            </p>
            <button
              onClick={onBindEmail}
              className="mt-3 inline-flex items-center gap-2 rounded-lg border border-accent/30 bg-accent/10 px-3 py-1.5 text-xs font-semibold text-accent hover:bg-accent/20"
            >
              {emailBound ? t('security.rebindEmail') : t('security.bindEmail')}
            </button>
          </div>

          {skipWarning && (
            <div className="rounded-xl border border-amber-500/30 bg-amber-500/10 p-3 text-xs text-amber-200">
              {t('security.skipWarning')}
            </div>
          )}
        </div>

        <div className="mt-5 flex justify-end">
          <button
            onClick={handleSkip}
            className="rounded-lg border border-glass-border px-4 py-2 text-xs font-semibold text-slate-300 hover:text-white hover:bg-glass-hover"
          >
            {skipWarning ? t('security.skipAcknowledge') : t('security.skip')}
          </button>
        </div>
      </div>
    </div>
  );
}
